export default "__VITE_ASSET__3b285432__"